import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@front/model'
import { ActivityTrailPage, Page, WebGlGuard } from '@components'

function ActivityTrailRoute(): ReactElement {
  const { t } = useTranslation()

  return (
    <WebGlGuard>
      <Page>
        <Page.Heading title={t('Activity Trail')} />
        <Page.Content noPadding>
          <ActivityTrailPage />
        </Page.Content>
      </Page>
    </WebGlGuard>
  )
}

export const Route = createFileRoute('/activityTrail/')({
  component: ActivityTrailRoute,
})
